<mat-card class="card-grey">
  <mat-card-title class="card-title">Bienvenido a Visor de Precios CIV-DL.</mat-card-title>
  <hr>
  <mat-card-subtitle class="mat-card-subtitle" style="color: black;">Para continuar es necesario asignes una nueva
    contraseña de acceso y nos
    indiques unas preguntas y
    respuestas de seguridad para<br> poder recuper tu contraseña en caso de que así lo necesites:
  </mat-card-subtitle>
  <mat-card-content>

    <form [formGroup]="usuarioForm" (ngSubmit)="onSubmit(usuarioForm.value)">
      <div>

        <div fxLayout="row" fxLayoutAlign="space-around center" fxLayoutGap="10px" fxLayout.sm="column"
          fxLayout.xs="column" class="div-conten-justify">
          <div fxFlex>
            <mat-form-field fxLayout="column" appearance="outline" class="full-width" floatLabel="always"
              hintLabel="Ingrese contraseña nueva">
              <mat-label>Nueva Contraseña</mat-label>
              <input matInput formControlName="password" name="password" [attr.colspan]="2" autocomplete="off" required>
              <mat-icon matSuffix >lock_open</mat-icon>
              <mat-error *ngIf="usuarioForm.controls['password'].hasError('required')">La Contraseña es requerida.</mat-error>
              <mat-error *ngIf="usuarioForm.controls['password'].hasError('minlength')">La Contraseña debe ser mínimo 06
                caracteres.</mat-error>
              <mat-error *ngIf="usuarioForm.controls['password'].hasError('pattern')">La Contraseña no cumple
                especificaciones.</mat-error>
            </mat-form-field>
          </div>
          <div fxFlex>
            <mat-form-field fxLayout="column" appearance="outline" class="full-width" floatLabel="always"
              hintLabel="Ingrese confirmación contraseña" class="div-conten-center">
              <mat-label>Confirmar Contraseña</mat-label>
              <input matInput formControlName="confirmPassword" name="confirmPassword" [attr.colspan]="2"
                autocomplete="off" required>
              <mat-icon matSuffix>lock</mat-icon>
              <mat-error *ngIf="usuarioForm.controls['confirmPassword'].hasError('required')">La Contraseña es requerida.</mat-error>
              <mat-error *ngIf="usuarioForm.controls['confirmPassword'].hasError('minlength')">La Contraseña debe ser mínimo 06
                caracteres.</mat-error>
              <mat-error *ngIf="usuarioForm.controls['confirmPassword'].hasError('pattern')">La Contraseña no cumple
                especificaciones.</mat-error>
              <mat-error
                *ngIf="usuarioForm.controls['confirmPassword'].hasError('mustMatch') && (usuarioForm.controls['confirmPassword'].touched || usuarioForm.controls['confirmPassword'].dirty ) && !usuarioForm.controls['confirmPassword'].errors?.['required']">
                Valores introducidos para las contraseñas deben coincidir.</mat-error>
            </mat-form-field>
          </div>
        </div>

        <div fxLayout="row" fxLayoutAlign="space-around center" fxLayoutGap="10px" fxLayout.sm="column"
          fxLayout.md="column" fxLayout.xs="column" class="div-conten-justify space">
          <p><b> El campo contraseña debe cumplir con las siguientes especificaciones:</b> Mínimo 6 caracteres con al
            menos una letra en mayúscula, una letra en minúscula, un valor numérico y un carácter especial: # ? ! &#64; S % & * .
            </p>
        </div>

        <div fxLayout="row" fxLayoutAlign="space-around center" fxLayoutGap="10px" fxLayout.sm="column"
          fxLayout.xs="column" class="div-conten-justify">
          <div fxFlex>

            <mat-form-field fxLayout="column" appearance="outline" class="select-width" floatLabel="always"
              hintLabel="Seleccione una opción" class="div-conten-center">
              <mat-label>Pregunta 1:</mat-label>
              <mat-select [(value)]="optionOne" formControlName="questionOne">
                <mat-option [value]="option.id" *ngFor="let option of questions">{{ option.value }}</mat-option>
              </mat-select>
              <mat-icon matSuffix>help</mat-icon>
              <mat-error *ngIf="usuarioForm.controls['questionOne'].hasError('required')">La Pregunta 1 es
                requerida.
              </mat-error>
            </mat-form-field>
          </div>
          <div fxFlex>
            <mat-form-field fxLayout="column" appearance="outline" class="select-width" floatLabel="always"
              hintLabel="Ingrese su respuesta">
              <mat-label>Respuesta:</mat-label>
              <input matInput formControlName="answerOne" name="answerOne" [attr.colspan]="2" autocomplete="off"
                required>
              <mat-icon matSuffix>done</mat-icon>
              <mat-error *ngIf="usuarioForm.controls['answerOne'].hasError('required')">La Respuesta 1 es
                requerida.
              </mat-error>
              <mat-error *ngIf="usuarioForm.controls['answerOne'].hasError('minlength')">La Respuesta 1 debe ser mínimo 04
                caracteres.</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-around center" fxLayoutGap="10px" fxLayout.sm="column"
          fxLayout.xs="column" class="div-conten-justify">
          <div fxFlex>
            <mat-form-field fxLayout="column" appearance="outline" class="select-width" floatLabel="always"
              hintLabel="Seleccione una opción" class="div-conten-center">
              <mat-label>Pregunta 2:</mat-label>
              <mat-select [(value)]="optionTwo" formControlName="questionTwo">
                <mat-option [value]="option.id" *ngFor="let option of questions">{{ option.value }}</mat-option>
              </mat-select>
              <mat-icon matSuffix>help</mat-icon>
              <mat-error *ngIf="usuarioForm.controls['questionTwo'].hasError('required')">La Pregunta 2 es
                requerida.
              </mat-error>
              <mat-error
                *ngIf="usuarioForm.controls['questionTwo'].hasError('mustMatch') && (usuarioForm.controls['questionTwo'].touched || usuarioForm.controls['questionTwo'].dirty ) && !usuarioForm.controls['questionTwo'].errors?.['required']">
                Valores introducidos para las preguntas no deben coincidir.</mat-error>
            </mat-form-field>
          </div>
          <div fxFlex>
            <mat-form-field fxLayout="column" appearance="outline" class="select-width" floatLabel="always"
              hintLabel="Ingrese su respuesta">
              <mat-label>Respuesta:</mat-label>
              <input matInput formControlName="answerTwo" name="answerTwo" [attr.colspan]="2" autocomplete="off"
                required>
              <mat-icon matSuffix>done</mat-icon>
              <mat-error *ngIf="usuarioForm.controls['answerTwo'].hasError('required')">La Respuesta 2 es
                requerida.
              </mat-error>
              <mat-error *ngIf="usuarioForm.controls['answerTwo'].hasError('minlength')">La Respuesta 2 debe ser mínimo 04
                caracteres.</mat-error>
            </mat-form-field>
          </div>
        </div>

      </div>

      <div fxLayoutAlign="center center" class="divconten">
        <p class="text-bold">(*) Estos campos son obligatorios.</p>
      </div>
      <mat-card-actions fxLayoutAlign="center center">
        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" fxLayout.sm="row" fxLayout.xs="column"
          class="div-conten-justify">
          <div fxLayout="column">
            <button mat-raised-button (click)="logoutAndCloseDialog();" color="warn" type="button" class="align-center-middle">
              <span class="text-icon-space">Regresar a Login</span>
              <mat-icon>exit_to_app</mat-icon>
            </button>
          </div>
          <div fxLayout="column">
            <button mat-raised-button color="primary" type="submit" class="align-center-middle">
              <span class="text-icon-space">Actualizar</span>
              <mat-icon>backup</mat-icon>
            </button>
          </div>
        </div>

      </mat-card-actions>

    </form>
  </mat-card-content>
</mat-card>
